import { BaseService } from './BaseService';
import { SlaughterForecastDashboard } from '../models/slaughter-forecast';

/**
 * `GET /dashboard/slaughter`, called through `BaseService` like its siblings on the dashboard controller
 * (`PigletRegistrationService`, `WeightMilestoneService`).
 */
export class SlaughterForecastService extends BaseService {
  url = '/dashboard/slaughter';

  /**
   * `farmId` scopes the response to a farm other than the token's own business unit, for the admin farms
   * overview. Omitted, the API answers for the signed-in business unit.
   */
  getDashboard = async (weeks: number, farmId?: string): Promise<SlaughterForecastDashboard> => {
    const query = this.BuildQueryString({ weeks, farmId });
    const result = await this.Fetch(`${this.url}?${query}`, 'GET');
    return this.FromResult<SlaughterForecastDashboard>(result);
  };
}

export default SlaughterForecastService;
